import { useEffect, useState } from "react";
import MensagemErro from "../MensagemErro";
import MensagemSucesso from "../MensagemSucesso";
import MensagemWarning from "../MensagemWarning";

const SnackBar = ({ objSnackBar, setObjSnackBar }) => {
  const [snackBar, setSnackBar] = useState({
    error: false,
    success: false,
    warning: false,
    msg: "",
  });

  const handleSnackBar = (type, msg = "") => {
    switch (type) {
      case "error":
        setSnackBar({
          success: false,
          error: true,
          warning: false,
          msg,
        });
        break;

      case "success":
        setSnackBar({
          success: true,
          error: false,
          warning: false,
          msg,
        });
        break;

      case "warning":
        setSnackBar({
          success: false,
          error: false,
          warning: true,
          msg,
        });
        break;

      case "close":
        setSnackBar({
          error: false,
          success: false,
          warning: false,
          msg: "",
        });
        if (typeof setObjSnackBar === "function") {
          setObjSnackBar({ type: "", msg: "" });
        }
        break;
    }
  };

  useEffect(() => {
    handleSnackBar(objSnackBar.type, objSnackBar.msg, objSnackBar.progressData);
  }, [objSnackBar]);

  return (
    <>
      <MensagemSucesso
        open={snackBar.success}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemWarning
        open={snackBar.warning}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />
    </>
  );
};

export default SnackBar;

//#region ------ Instruções

// Importação:

// <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />

// Necessário função para administração de estado junto de useState:
// const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

//types aceitos: error, success, warning, progress, close

// const handleSnackBar = (obj) => {
//   setObjSnackBar(obj);
// };

// Para progresso com barra no topo:
// setObjSnackBar({
//   type: "progress",
//   msg: "Executando motores...",
//   progressData: {
//     progresso: 50,
//     etapaAtual: 2,
//     totalEtapas: 4,
//     descricao: "Processando dados...",
//     tempoEstimado: "~1 minuto restante"
//   }
// });
